var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulbSketch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1994 27.4962C41.6449 16.378 22.9303 18.8246 20.2571 31.0386C18.6442 38.4085 25.4452 43.5662 26.3236 50.4678H41.9145C42.373 48.6224 43.3057 46.4276 43.9517 45.0785C45.2941 42.2759 47.1929 40.444 47.9139 37.3173C48.5997 34.3422 48.5203 30.1407 47.1994 27.4962Z",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0379 59.8739C26.0334 57.7443 25.9289 55.6147 25.9658 53.4857C25.9805 52.6426 25.8365 51.6114 26.5661 51.022C27.6316 50.1617 29.2164 50.0364 30.5386 50.0045C33.0169 49.9453 35.5142 49.9661 37.9949 49.9712C39.1247 49.9732 40.8109 49.777 41.8292 50.3384C42.7984 50.8718 43.0437 52.3257 43.1527 53.3077C43.3617 55.1895 43.918 59.3914 42.3205 60.8481C41.3143 61.7657 39.7448 61.9577 38.4563 62.1164C35.0382 62.5369 26.043 62.4534 26.0379 59.8739Z",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1476 62.2971C35.1755 63.4561 35.1892 64.6212 35.098 65.7783",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11707 44.6054C9.33313 43.9635 10.6031 43.4355 11.8322 42.8216",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11707 19.6594C9.47451 20.5214 10.7731 21.474 12.1336 22.3286",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9062 9.4431C34.8584 7.7359 34.869 6.04093 34.9236 4.33435",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9219 21.0723C57.626 19.9443 59.3809 18.8846 61.1142 17.8018",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9467 44.3338C54.2608 45.5114 55.5804 46.6754 56.8523 47.8989",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbSketch);
export default __webpack_public_path__ + "static/media/bulb-sketch.fe975ad17d1494d0dc682c81f77f05cf.svg";
export { ForwardRef as ReactComponent };